"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPriceDisplay;

var _decimalFormatter = _interopRequireDefault(require("./decimalFormatter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getPriceValues = function getPriceValues(price) {
  var isRange = price.type === 'range';
  var minPrice = isRange ? price.min : price;
  var sales = minPrice.sales,
      list = minPrice.list;
  var retailPrice = list ? (0, _decimalFormatter["default"])(list.formatted) : (0, _decimalFormatter["default"])(sales.formatted);
  return {
    salesPriceDisplay: "".concat(isRange ? 'From ' : '').concat((0, _decimalFormatter["default"])(sales.formatted)),
    retailPriceDisplay: isRange ? "From ".concat(retailPrice) : "".concat(retailPrice, " full price"),
    retailPriceValue: retailPrice,
    priceValue: list ? list.value : sales.value,
    salesPriceValue: sales.value
  };
};

var getPriceStatus = function getPriceValues(price) {
  var isRange = price.type === 'range';
  var minPrice = isRange ? price.min : price;
  var sales = minPrice.sales,
      list = minPrice.list;
  var isFree = sales && sales.formatted === 'Free';
  var onSale = !isFree && list !== null;
  return {
    isFree: isFree,
    onSale: onSale
  };
};

var getRebateValues = function getRebateValues(rebatePrice) {
  if (rebatePrice) {
    var price = rebatePrice.type === 'range' ? rebatePrice.min.sales : rebatePrice.sales;
    var rebate = rebatePrice.type === 'range' ? "".concat((0, _decimalFormatter["default"])(rebatePrice.min.sales.formatted), " - ").concat((0, _decimalFormatter["default"])(rebatePrice.max.sales.formatted)) : (0, _decimalFormatter["default"])(rebatePrice.sales.formatted);
    return {
      hasRebates: true,
      rebatePriceDisplay: "".concat(rebate),
      rebatePriceValue: price.value
    };
  }

  return {
    hasRebates: false,
    rebatePriceDisplay: ''
  };
};

var getAddOnValues = function getAddOnValues(addOns) {
  if (!addOns) {
    return null;
  }

  var addOnPriceDisplay = addOns.reduce(function (out, addOn) {
    var values = addOn.values;

    if (values.minAddOnPrice === values.maxAddOnPrice) {
      out[addOn.id] = "".concat((0, _decimalFormatter["default"])(values.minAddOnPriceFormatted));
    } else {
      out[addOn.id] = "".concat((0, _decimalFormatter["default"])(values.minAddOnPriceFormatted), " - ").concat((0, _decimalFormatter["default"])(values.maxAddOnPriceFormatted));
    }

    return out;
  }, {});
  return {
    addOnPriceDisplay: addOnPriceDisplay
  };
};

function getPriceDisplay(price, rebatePrice, addOns) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getPriceValues(price)), getPriceStatus(price)), getRebateValues(rebatePrice)), getAddOnValues(addOns));
}